document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('.product-tabs__tab');
  const panels = document.querySelectorAll('.product-tabs__panel');

  tabs.forEach((tab, index) => {
    const panel = panels[index];
    if (!panel) return;

    // Prüfen, ob Geschmacksprofil existiert
    const tasteProfile = panel.querySelector('.taste-profile');

    if (!tasteProfile) {
      tab.style.display = 'none';
      panel.style.display = 'none';
    }
  });
});
